module.exports = __webpack_public_path__ + "media/stylesheets/images/banner-5836a5699b5850e2880924cce8d3247f.jpg";